import config from '../config'

class SiteMessages {
    constructor() {
        this.container = document.getElementById('site-messages-container')

        if (this.container) {
            this.track = document.getElementById('site-messages')
            this.items = this.track.querySelectorAll('.site-messages__message')
            this.previousButton = document.getElementById(
                'site-messages-previous'
            )
            this.nextButton = document.getElementById('site-messages-next')

            this.index = 0

            if (this.container) {
                this.bindEventListeners()
                this.init(0)
            }
        }
    }

    bindEventListeners() {
        if (this.previousButton)
            this.previousButton.addEventListener('click', (e) =>
                this.handlePrevious(e)
            )
        if (this.nextButton)
            this.nextButton.addEventListener('click', (e) => this.handleNext(e))
    }

    handlePrevious(e) {
        e.preventDefault()

        this.setItem(this.index === 0 ? this.items.length - 1 : 0)
    }

    handleNext(e) {
        e.preventDefault()

        this.setItem(this.index === this.items.length - 1 ? 0 : this.index + 1)
    }

    setItem(index = 0) {
        this.items[this.index].classList.remove('active')

        this.index = index
        this.items[index].classList.add('active')

        this.track.style.transform = `translate3d(-${100 * index}%, 0, 0)`
    }

    init() {
        console.log('init')
    }
}

export default SiteMessages
